import { useQuery } from '@tanstack/react-query';
import { useAbortSignal } from '@frontend/utils/hooks/useAbortSignal';
import { fetchOutpatientClinicTasksMetadata } from '../services/fetchOutpatientClinicTasksMetadata';

export function useOutpatientClinicTasksMetadata() {
    const abortSignal = useAbortSignal();
    const { data, isLoading, error } = useQuery({
        queryFn: () =>
            fetchOutpatientClinicTasksMetadata({
                abortSignal,
            }),
        queryKey: ['outpatient-clinic-tasks-metadata'],
    });

    return {
        data,
        error,
        isLoading,
    };
}
